import CN from './zh-CN.js'
import US from './en-US.js'

export { CN, US }


// WEBPACK FOOTER //
// ./src/locals/index.js